import { render, staticRenderFns } from "./NewEmailEditor.vue?vue&type=template&id=79245a1f"
import script from "./NewEmailEditor.vue?vue&type=script&lang=js"
export * from "./NewEmailEditor.vue?vue&type=script&lang=js"
import style0 from "./NewEmailEditor.vue?vue&type=style&index=0&id=79245a1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports